import { EnumOption } from './enum-option';

export const FieldUIType = {
  Text: 0,
  Notes: 1,
  Integer: 2,
  Decimal: 3,
  Boolean: 4,
  DateOnly: 5,
  Country: 6,
  Choice: 7,
  Lookup: 8,
};

export interface FieldUISubType {
  key: number;
  name: string;
  allowMultiple: boolean;
}

export interface FieldUITypeModel {
  key: number;
  name: string;
  subTypes: FieldUISubType[] | null;
}

export const FieldUITypeList: EnumOption[] = [
  { value: FieldUIType.Text, label: 'Text' },
  { value: FieldUIType.Notes, label: 'Notes' },
  { value: FieldUIType.Integer, label: 'Integer' },
  { value: FieldUIType.Decimal, label: 'Decimal' },
  { value: FieldUIType.Boolean, label: 'Boolean' },
  { value: FieldUIType.DateOnly, label: 'DateOnly' },
  { value: FieldUIType.Country, label: 'Country' },
  { value: FieldUIType.Choice, label: 'Choice' },
  { value: FieldUIType.Lookup, label: 'Lookup' }
];

export const ChoiceSubTypes: FieldUISubType[] = [
  { key: 0, name: 'Gender', allowMultiple: false },
  { key: 1, name: 'Education Level', allowMultiple: false },
  { key: 3, name: 'Marital Status', allowMultiple: false },
  { key: 2, name: 'Immigrant Status', allowMultiple: false },
  { key: 4, name: 'Visa Category', allowMultiple: false },
  { key: 5, name: 'Visa Type', allowMultiple: false },
  { key: 6, name: 'Custom Options', allowMultiple: true }
];

export const CompleteFieldUITypeList: FieldUITypeModel[] = [
  { key: FieldUIType.Text, name: 'Text', subTypes: null },
  { key: FieldUIType.Notes, name: 'Notes', subTypes: null },
  { key: FieldUIType.Integer, name: 'Integer', subTypes: null },
  { key: FieldUIType.Decimal, name: 'Decimal', subTypes: null },
  { key: FieldUIType.Boolean, name: 'Boolean', subTypes: null },
  { key: FieldUIType.DateOnly, name: 'DateOnly', subTypes: null },
  { key: FieldUIType.Country, name: 'Country', subTypes: null },
  {
    key: FieldUIType.Choice,
    name: 'Choice',
    subTypes: ChoiceSubTypes
  },
  { key: FieldUIType.Lookup, name: 'Lookup', subTypes: null }
];

export function getFieldUITypeName(typeKey: number): string {
  const type = FieldUITypeList.find(t => t.value === typeKey);
  return type ? type.label : 'Unknown';
}

export function getChoiceSubTypeOptions(): EnumOption[] {
  return ChoiceSubTypes.map(subType => ({
    value: subType.key,
    label: subType.name
  }));
}
